import { render, staticRenderFns } from "./Comlit.vue?vue&type=template&id=534ac2ab&"
import script from "./Comlit.vue?vue&type=script&lang=js&"
export * from "./Comlit.vue?vue&type=script&lang=js&"
import style0 from "./Comlit.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports